import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

/**
 * Component used to group together items within a card.
 *
 * **Base CSS Class:** `ph-card-group`
 */
export default function CoreCardGroup(props) {
	return (
		<div className={classnames('ph-card-group', props.className)}>
			{props.children}
		</div>
	);
}

CoreCardGroup.propTypes = {
	children: PropTypes.node,
	className: PropTypes.string,
};
